module.exports = __webpack_public_path__ + "static/img/spinner.407b376.svg";